import { useQuery, keepPreviousData } from '@tanstack/vue-query'
import fetchApi from '@/utils/fetchApi'
import type { VariablesListResponse } from 'shared/src'
import { computed, type MaybeRef, toValue } from 'vue'

export interface VariablesListParams {
  q?: string
  page?: number
  limit?: number
}

export const variablesListQueryKey = (params: VariablesListParams) =>
  ['variables', 'list', params] as const

export function useVariablesListQuery(params: MaybeRef<VariablesListParams>) {
  const queryKey = computed(() => variablesListQueryKey(toValue(params)))

  return useQuery({
    queryKey,
    queryFn: async () => {
      const p = toValue(params)
      const query: Record<string, string | number> = {}

      if (p.q) query.q = p.q
      if (p.page) query.page = p.page
      if (p.limit) query.limit = p.limit

      return await fetchApi<VariablesListResponse>({
        endpoint: '/api/variables/list',
        method: 'GET',
        query,
      })
    },
    placeholderData: keepPreviousData,
  })
}
